import React from "react";
import BaseHeader from "@fig/client/components/Header";
import classes from "./Header.module.scss";
import {solutions} from "@fig/client/routes/Solutions/data/solutions";
// @spellchecker: words tabler
import {IconCalculator} from "@tabler/icons-react";

interface HeaderProps {
  openWaitlist?: any;
  darkMode?: boolean;
}

export default function Header({openWaitlist, darkMode}: HeaderProps) {
  return (
    <BaseHeader
      darkMode={darkMode}
      links={[
        {
          label: "Solutions",
          dropdown: {
            title: "Industry specific solutions",
            viewAllLink: "/solutions",
            footer: {
              title: "Are you ready to start saving?",
              description: "Join our waitlist to get an invite to our early access group",
              linkLabel: "Join Waitlist",
              linkOnClick: openWaitlist,
              //link: undefined,
            },
            subLinks: Object.keys(solutions).map((key) => ({
              link: `/solutions/${key}`,
              label: solutions[key].name,
              description: solutions[key].description,
              icon: solutions[key].icon,
            })),
          },
        },
        {
          label: "Tools",
          dropdown: {
            title: "Great financial tools",
            //viewAllLink: "/tools",
            footer: {
              title: "Are you ready to start saving?",
              description: "Join our waitlist to get an invite to our early access group",
              linkLabel: "Join Waitlist",
              linkOnClick: openWaitlist,
              //link: undefined,
            },
            subLinks: [
              {
                link: `/tools/retirement-compound-interest-calculator`,
                label: "Compound Interest Calculator",
                description: "Calculate the future value of your investments",
                icon: IconCalculator,
              },
              {
                link: `/tools/freelancer-rate-calculator`,
                label: "Freelancer Rate Calculator",
                description: "Calculate your hourly rate to meet your financial goals",
                icon: IconCalculator,
              },
            ],
          },
        },
        {link: `/resources`, label: "Resources"},
      ]}
      primaryLink={
        openWaitlist
          ? {
              onClick: async () => openWaitlist(),
              label: "Join the waitlist",
            }
          : undefined
      }
    />
  );
}
